import useSWRMutation, { type SWRMutationConfiguration } from 'swr/mutation';

import {
  putNotificationPreferences,
  type PutNotificationPreferencesParams,
  type PutNotificationPreferencesResponse,
} from '@services/UsersService';

export type UsePutNotificationPreferencesParams = {
  mutationOptions?: SWRMutationConfiguration<
    PutNotificationPreferencesResponse,
    unknown,
    string,
    PutNotificationPreferencesParams,
    PutNotificationPreferencesResponse
  >;
};

export const putNotificationPreferencesMutationKey =
  'put-notification-preferences';

export const usePutNotificationPreferences = ({
  mutationOptions,
}: UsePutNotificationPreferencesParams = {}) => {
  const { trigger, ...swrResponse } = useSWRMutation<
    PutNotificationPreferencesResponse,
    unknown,
    string,
    PutNotificationPreferencesParams
  >(
    putNotificationPreferencesMutationKey,
    (_url, { arg }) => putNotificationPreferences(arg),
    mutationOptions,
  );

  return {
    trigger,
    ...swrResponse,
  };
};
